import { Pipe, PipeTransform } from '@angular/core';

import { BuiltLocalRoom } from '@models/commutiny-chat/built-local-room.model';

@Pipe({ name: 'extension' })
export class ExtensionPipe implements PipeTransform {
  transform(path: string | null): string {
    if (path) return path.split('.').at(-1) ?? '';
    return '';
  }
}
